import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Secretaria = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchSecretarias()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.secretaria.nome} - {props.secretaria.sigla}</Card.Title>
                        <p>Secretário(a):<strong> {props.secretaria.secretario}</strong></p>
                        <p>Endereço:<strong> {props.secretaria.endereco}</strong></p>
                        <p>Horários de Funcionamento:<strong> {props.secretaria.horarios}</strong></p>
                        <p>Telefone:<strong> {props.secretaria.telefone}</strong></p>
                        <p>E-mail:<strong> {props.secretaria.email}</strong></p>
                    </Card.Body>
                    <Button type="button" className="botao-leis" onClick={() => editar(props.secretaria._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.secretaria._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Secretaria;